import React, { FC, forwardRef } from 'react';
import { Switch as MuiSwitch } from '@material-ui/core';
import { SwitchProps } from '@material-ui/core/Switch';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    top: theme.spacing(-1),
    right: -theme.spacing(1),
  },
}));

const Switch: FC<SwitchProps> = forwardRef((props, ref) => {
  const classes = useStyles();

  return <MuiSwitch ref={ref} className={classes.root} {...props} />;
});

export default Switch;
